import * as Api from '../utils/API';
import {
    BIPARCEIRO_VENDEDOR,
    BIPARCEIRO_VENDEDORLOADING,
    BIPARCEIRO_LIST,
    BIPARCEIRO_LISTLOADING,
    BIPARCEIRO_STATUS_CLEAR,
    BIPARCEIRO_STATUS_LOADING,
    BIPARCEIRO_STATUS_SUCCESS,
    BIPARCEIRO_STATUS_ERROR
} from '../actions/ActionsTypes';

const statusErrorMessage = (status) => {
    switch (status) {
        case 400:
            return 'Informe um código de parceiro válido.';
        case 403:
            return 'Acesso negado.';
        case 404:
            return 'Parceiro não encontrado.';
        default:
            return 'Não foi possível consultar o status do parceiro.';
    }
};

let nextStatusRequestId = 0;

export const BIParceiroVendedorActions = (userid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: BIPARCEIRO_VENDEDORLOADING, payload: true });
        Api.getBIParceiroVendedores(userid).then(dados => {
            dispatch({ type: BIPARCEIRO_VENDEDOR, payload: dados })
            dispatch({ type: BIPARCEIRO_VENDEDORLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const BIParceiroListActions = (userid, codvend) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: BIPARCEIRO_LISTLOADING, payload: true })
        Api.getBIParceiroList(userid, codvend).then(dados => {
            dispatch({ type: BIPARCEIRO_LIST, payload: dados })
            dispatch({ type: BIPARCEIRO_LISTLOADING, payload: false })
            resolve([])
        }).catch(error => {
            reject(error);
        })
    });

export const BIParceiroStatusActions = (codparc) => async (dispatch) => {
    const requestId = ++nextStatusRequestId;
    const meta = { requestId };

    dispatch({ type: BIPARCEIRO_STATUS_CLEAR, meta });
    dispatch({ type: BIPARCEIRO_STATUS_LOADING, meta });

    try {
        const dados = await Api.getBIParceiroStatus(codparc);
        dispatch({ type: BIPARCEIRO_STATUS_SUCCESS, payload: dados, meta });
        return dados;
    } catch (error) {
        dispatch({
            type: BIPARCEIRO_STATUS_ERROR,
            payload: {
                status: error.status || 500,
                message: statusErrorMessage(error.status)
            },
            meta
        });
        throw error;
    }
};
